<template>

	<div>

		<div class="row" v-if="contest">
			<div class="col-md-12">
				<contest-header/>
			</div>
		</div>

		<div class="row">

            <div class="lg:flex lg:flex-wrap lg:flex-row-reverse">
                <div class="enter w-full lg:w-3/5">
                    <div class="cell example example2">
                        <user-form
                            :submit-form="completeSubmit"
                        ></user-form>
                    </div>
                </div>

                <div
                    class="w-full lg:w-2/5 pr-5"
                    style="margin-top: 18px;"
                >
                    <h1
                        class="text-3xl"
                    >
                        {{ contest.enter_title }}
                    </h1>
                    <div v-html="contest.enter_content"></div>
                    <div>
                        <h4>Share with your friends!</h4>

                        <div class="share-buttons-container flex">

                            <a class="share-icon"
                               :href="'https://www.facebook.com/sharer/sharer.php?u=' + MAIN_URL + '/contests/' + contest.slug + '/entries/' + '&quote=' + share_text"
                               target="_blank">
                                <div class="facebook-icon">
                                    <facebook-icon/>
                                </div>
                            </a>

                            <a class="share-icon"
                               :href="'http://twitter.com/share?url=' + MAIN_URL + '/contests/' + this.contest.slug + '/entries/' + '&text=' + share_text"
                               target="_blank">
                                <div>
                                    <twitter-icon/>
                                </div>
                            </a>

                            <a class="link-icon-container share-icon"
                               :href="'mailto:?subject=' + share_text + '&body=' + share_text">
                                <email-icon/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import {ENV_URL, MAIN_URL, STRIPE_PUBLISHABLE} from '../../environment.js';
import ContestHeader from '@/js/components/contests/ContestHeader.vue';
import queryString from 'qs';
import axios from 'axios';
import FacebookIcon from '@/js/components/ui/FacebookIcon.vue';
import TwitterIcon from '@/js/components/ui/TwitterIcon.vue';
import EmailIcon from '@/js/components/ui/EmailIcon.vue';
import UserForm from "./UserForm";
import { sendContestForm } from "@/js/plugins/hubspot.js";

var smoothScroll = require('smoothscroll');



export default {
	name: 'contests-contest-entries-entry-complete',
	components: {
        UserForm,
		ContestHeader,
		FacebookIcon,
		TwitterIcon,
		EmailIcon,
	},
	data() {
		return {
			places: null,
			displayMobileFilters: false,
			MAIN_URL: MAIN_URL,
			coupon: '',
			save_card_info: true,
			hidePaymentForm: false,
			copiedData: null,
		}
	},
	created() {
		const uri = ENV_URL + this.$route.path;
		let test = this.$store.dispatch('CONTESTS_CONTEST_ENTRIES_ENTRY_COMPLETE', {uri: uri}).then(() => {
		})
		// }
	},
	computed: {
		loading() {
			return this.$store.state.loading;
		},
		entryForm() {
			return this.$store.state.entryForm;
		},
		displayMobileFiltersClass() {
			return this.displayMobileFilters ? 'filter mobile' : 'filter';
		},
		user() {
			return this.$store.state.user;
		},
		addonForm() {

			return this.$store.state.addonForm;
		},
		userForm() {
			return this.$store.state.userForm;
		},
		page() {

			return this.$store.state.page;
		},
		contest() {
			return this.$store.state.contest;
		},

		contestApis() {
			return this.$store.state.contestApis;
		},
		share_text() {
			return this.$store.state.contest ? "Check out the " + this.contest.title + " Contest!" : '';
		},
		total() {

			let total = 0;
			if (this.addonForm) {
				this.addonForm.fields.map((field) => {
					if (field.field_type === 'purchase' && field.value === true) {
						total += field.price;

					}

				})
			}

			total == 0 ? this.hidePaymentForm = true : "";
			return total;

		},
		couponCodeFree() {
			return this.coupon === 'NJstudent22';
		}

	},
	serverAsyncData({store, to, from}) {
		const state = store.state;
		// Set the rest of the searchOptions using the query.
		// to and from are undefined when coming from a different page
		// and when the page first loads, so use the query in the route
		let route = {};
		if (to !== undefined) {
			route = to;
		} else if (from === undefined) {
			route = state.route;
		} else {
			route = state.route.from
		}
		const uri = ENV_URL + route.path;
		return store.dispatch('CONTESTS_CONTEST_ENTRIES_ENTRY_COMPLETE', {uri: uri});
	},

	metaInfo() {

		let title = '';
		let query = Object.assign({}, this.$route.query);

		if (query['hcategory.lvl1']) {
			const categories = query['hcategory.lvl1'].split(',');
			const categorySections = categories[0].split(' > ');
			title = categorySections[1] + ' ' + categorySections[0]
		} else {
			title = this.section;
		}


		if (query['city']) {
			title += ' in ' + query['city'];
		}

		return this.$seo('item', title)
	},

	methods: {
		saveCardInfo(e) {
			this.save_card_info = e.target.checked;
		},

		getCookie(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		// Finally, send all the data (user's data, entry, data, payment data)
		// to the server (contestsapi.njmonthly.com)
		completeSubmit(uri, data, authHeaders) {
			axios.post(uri, data, authHeaders).then((response) => {
                if (response.data.error === true) {
                    alert(response.data.message);
                } else {
                    this.sendHubspotFormPushThankYou(data);
                    if (window.fbq) {
                        fbq('track', 'Purchase', {
                            value: 30,
                            currency: 'USD',
                        });
                        // Calculate how much the user paid
                        // and include it in FB and GA
                        let total = 0;
                        if (this.addonForm) {
                            this.addonForm.fields.map(function (field) {
                                if (field.name === 'entry') {
                                    total += field.price;
                                }
                            })
                        }
                        window.fbq.push('track', 'Purchase', {
                                content_name: this.contest.slug,
                                content_category: 'contest',
                                content_type: 'product',
                                value: this.total,
                                currency: 'USD'
                            }
                        );
                    }
                    this.$gtag.event('Purchase', {
                        'event_category': 'Contests',
                        'event_label': this.contest.slug,
                        'value': this.total
                    })
                }

            }).catch((err) => {
                this.$store.dispatch('LOADING', false);
                if (err) {
                    console.error(err)
                }
            })
		},

        sendHubspotFormPushThankYou(data) {
            // submit the hubspot form
            const hubspotData = {
                formData: {
                    name: data.formData.name,
                    last_name: data.formData.last_name,
                    email: this.user.email,
                    address_line1: data.formData.address_line1,
                    address_city: data.formData.address_city,
                    address_state: data.formData.address_state,
                    address_phone: data.formData.address_phone,
                    address_zip: data.formData.address_zip,
                    subscribe_to_njm_newsletter: data.formData.subscribe_to_njm_newsletter,
                    subscribe_to_sponsored_newsletter: data.formData.subscribe_to_sponsored_newsletter,
                    purchase_njm_magazine_subscription: data.formData.purchase_njm_magazine_subscription,
                },
            }
            sendContestForm(hubspotData, this.contest.slug).then((res) => {
                //
            }).finally(() => {
                // even if hubspot errors out, go to the Thank You page to prevent users from double submitting
                this.$router.push({path: '/contests/' + this.contest.slug + '/purchase-complete', query: {}})
                this.$store.dispatch('LOADING', false);
            })
        },
		getDataValues(data, is_addon) {
			let output = {};
			data.map((info) => {

				console.dir(info)
				if (is_addon && info.type == 'checkbox') {
					output[info.name] = !info.value ? 'No' : 'Yes';
				} else {
					output[info.name] = info.value;
				}

				//  let index = data[info].name;
				//  let value = data[info].value;
				//  output[index] = value;
			});
			return output;
		},
	},
}


</script>

<style lang="scss">
.hide {
	display: none;
}

.show {
	display: block;
}

.user-view {
	background-color: #fff;
	box-sizing: border-box;
	padding: 2em 3em
}

.user-view h1 {
	margin: 0;
	font-size: 1.5em
}

.user-view .meta {
	list-style-type: none;
	padding: 0
}

.user-view .label {
	display: inline-block;
	min-width: 4em
}

.user-view .about {
	margin: 1em 0
}

.user-view .links a {
	text-decoration: underline
}

.pagination > .active > a, .pagination > .active > a:focus, .pagination > .active > a:hover, .pagination > .active > span, .pagination > .active > span:focus, .pagination > .active > span:hover {

	background-color: #159b5d;
	border-color: #159b5d;

}
</style>

